import React from "react";
import NavAndHero from "../components/NavAndHero";
import CallToAction from "../components/CTA";
import Footer from "../components/Footer";
import { ReactComponent as AboutImage } from "../images/undraw_stand-out_alq4.svg"; // Use your preferred SVG

const AboutPage = () => {
  return (
    <div data-theme="light">
      <NavAndHero />

      {/* Hero Intro */}
      <section className="bg-blue-500 rounded-b-3xl py-20 px-4 text-center">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-4xl md:text-5xl font-bold text-white">
            About Digiscape
          </h1>
          <p className="text-lg text-gray-100">
            We're not just a digital marketing and IT company — we're your growth partner. Whether you're building your first site, scaling your business, or launching a marketing campaign, Digiscape makes it easy, effective, and affordable.
          </p>
        </div>
      </section>

      {/* Side-by-side Section */}
      <section className="py-20 px-6 bg-base-100">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-7xl mx-auto items-center">
          {/* Text */}
          <div className="space-y-5">
            <h2 className="text-3xl font-bold text-blue-500">Client-First, Always</h2>
            <p className="text-gray-700">
              At Digiscape, our clients aren't just customers — they're our collaborators. We listen, we adapt, and we communicate every step of the way. Whether it's a website, IT support, or a marketing campaign, your success is our mission.
            </p>
            <p className="text-gray-700">
              We're proud of our ability to take your vision and turn it into digital results. Every project is treated with care, attention, and a commitment to high-quality work.
            </p>
          </div>

          {/* Image */}
          <div className="flex justify-center">
            <AboutImage className="w-full max-w-md h-auto" />
          </div>
        </div>
      </section>

      {/* How Easy It Is Section */}
      <section className="bg-blue-100 py-20 px-6">
        <div className="max-w-4xl mx-auto space-y-6 text-center">
          <h2 className="text-3xl font-bold text-blue-600">Working With Us Is Effortless</h2>
          <p className="text-gray-700 text-lg">
            We’ve simplified the entire process to make your experience stress-free. From our streamlined onboarding and transparent communication to project updates and fast delivery — we make it smooth from start to finish.
          </p>
        </div>
      </section>

      {/* Best Rates Section */}
      <section className="py-20 px-6 text-center bg-yellow-100">
        <div className="max-w-3xl mx-auto space-y-6">
          <h2 className="text-3xl font-bold text-yellow-600">Best Rates in the GTA 🏆</h2>
          <p className="text-lg text-gray-800">
            We offer unmatched value without cutting corners. Our pricing is designed to give startups, small businesses, and entrepreneurs in the Greater Toronto Area access to premium services at honest, transparent rates.
          </p>
          <p className="font-semibold">Let us show you what quality and affordability really looks like.</p>
        </div>
      </section>

      <div id="cta">
        <CallToAction />
      </div>
      <Footer />
    </div>
  );
};

export default AboutPage;
